import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { RegisterForm } from '@/components/auth/register-form'
import { useAuthStore } from '@/stores/auth-store'

export default function RegisterPage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, navigate])

  const handleRegisterSuccess = () => {
    navigate('/', { replace: true })
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-orange-500 mb-2">
            KookInspiratie
          </h1>
          <p className="text-gray-600">
            Jullie weekmenu en recepten op één plek
          </p>
        </div>
        
        <RegisterForm onSuccess={handleRegisterSuccess} />
      </div>
    </div>
  )
}